jQuery( function ( $ ) {

  const $modal = $( '#WatchVideo' );
  const $container = $( '.video-contaienr', $modal );
  const $frame = $( '<iframe>' )
    .addClass( 'responsive-iframe w-100' )
    .attr( 'height', 300 )
    .attr( 'title', 'YouTube video player' )
    .attr( 'frameborder', 0 )
    .attr( 'allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' )
    .prop( 'allowfullscreen', true )

  $modal.on( 'show.bs.modal', function ( e ) {
    const id = $( e.relatedTarget ).data( 'video-id' );
    var url = new URL( `https://www.youtube.com/embed/${ id }` );
    url.searchParams.set( 'enablejsapi', 1 );
    $frame.attr( 'src', url.href );
    $container.append( $frame );
  });

});